import { render, staticRenderFns } from "./DonationSuccess.vue?vue&type=template&id=5e47976f&"
import script from "./DonationSuccess.vue?vue&type=script&lang=js&"
export * from "./DonationSuccess.vue?vue&type=script&lang=js&"
import style0 from "./DonationSuccess.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports